export default {
  '3D展示': '3D Display',
  '3D展览': 'Virtual Exhibition',
}
